import { registerPlugin } from '@capacitor/core';

import type { SnapSharePlugin } from './definitions';

const SnapShare = registerPlugin<SnapSharePlugin>('SnapShare', {
    web: () => import('./web').then((m) => new m.SnapShareWeb()),
});

export * from './definitions';
export { SnapShare };
